import { render, staticRenderFns } from "./TravelCell.vue?vue&type=template&id=0f8a52ae&scoped=true&"
import script from "./TravelCell.vue?vue&type=script&lang=js&"
export * from "./TravelCell.vue?vue&type=script&lang=js&"
import style0 from "./TravelCell.vue?vue&type=style&index=0&id=0f8a52ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a52ae",
  null
  
)

export default component.exports